import { useQuery } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"
import { DateFilter } from "@/types/filters"

export interface TimeMetric {
  stage: string
  stageName: string
  averageDuration: number // in hours
  completionCount: number
  durations: number[]
}

export interface TimeMetricsData {
  stageDurations: TimeMetric[]
  avgTimeToCompletion: number
  completedApplicationsCount: number
}

interface TimeMetricsResponse {
  success: boolean
  data: TimeMetricsData
}

/**
 * Hook to fetch time metrics data from Supabase Edge Function
 * @param dateFilter - The date filter to apply with startDate and endDate
 */
export const useTimeMetricsData = (dateFilter: DateFilter = {}, jobId?: string) => {
  return useQuery({
    queryKey: ["timeMetricsData", dateFilter, jobId ?? "all"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("metrics-time-metrics", {
        body: {
          startDate: dateFilter.startDate,
          endDate: dateFilter.endDate,
          jobId: jobId ?? null,
        },
      })

      if (error) {
        throw new Error(`Error fetching time metrics data: ${error.message}`)
      }

      if (!data || !data.success) {
        throw new Error("Failed to fetch time metrics data")
      }

      const response = data as TimeMetricsResponse
      return response.data
    },
  })
}
